import { useAppSelector } from 'reduxTyped'
import { AccountUserDisplayFlagType } from 'apps/dashboard/constants/DisplayFlagType'
import { getIsCurrentAccountUserDisplayFlagEnabled } from 'apps/dashboard/selectors/dashboardSelectors'
import * as devLogSelectors from 'common/settings/LogsSection/model/selectors'

import { SettingsTabType } from '../constants/SettingsTabType'

export const useSettingsTabWithNotification = () => {
  const hasNotifications = useAppSelector(devLogSelectors.getHasUnreadNotifications)
  const hasPolicyEnforcementNotifications = useAppSelector((state) =>
    getIsCurrentAccountUserDisplayFlagEnabled(
      state,
      AccountUserDisplayFlagType.HIGHLIGHT_LOGS_ON_FB_POLICY_ENFORCEMENT,
    ),
  )

  if (hasNotifications) {
    return SettingsTabType.LOGS
  }
  if (hasPolicyEnforcementNotifications) {
    return SettingsTabType.FB_POLICY_ENFORCEMENT_LOGS
  }

  return null
}
